import * as React from 'react';
import Hero, { Props as HeroProps } from './Hero';
import Brands, { Props as BrandsProps } from './Brands';
import News, { Props as NewsProps } from './News';
import TextAndImage, { Props as TextAndImageProps } from './TextAndImage';
import FourImagesGrid, { Props as FourImagesGridProps } from './FourImagesGrid';
import Positions, { Props as PositionsProps } from './Positions';
import Employees, { Props as EmployeesProps } from './Employees';
import InstagramBlock, { Props as InstaProps } from './InstagramBlock';
import Timeline, { Props as TimelineProps } from './Timeline';
import Citation, { Props as CitationProps } from './Citation';
import Slider, { Props as SliderProps } from './Slider';
import Offices, { Props as OfficesProps } from './Offices';
import Visit, { Props as VisitProps } from './Visit';
import Connect, { Props as ConnectProps } from './Connect';
import WpForm, { Props as WpFormProps } from './WpForm';
import ContactForm, { Props as ContactFormProps } from './ContactForm';
import FreeText, { Props as FreeTextProps } from './FreeText';
import ThreeColumnGrid, {
  Props as ThreeColumnGridProps,
} from './ThreeColumnGrid';
import Vimeo, { Props as VimeoProps } from './Vimeo';
import Portfolios, { PortfoliosProps } from './Portfolios';
import FullScreenImage, { FullScreenImageProps } from './FullScreenImage';
import Newsposts, { NewspostsProps } from './Newsposts';
import NewsletterformSection, {
  NewsletterformSectionProps,
} from './NewsletterformSection';
import WTRegistrationPopupSection, {
  WTRegistrationPopupSectionProps,
} from './WTRegistrationPopupSection';

export type Props = {
  _blocks: Props[];
  internal: {
    type: string;
  };
} & HeroProps &
  BrandsProps &
  NewsProps &
  TextAndImageProps &
  FourImagesGridProps &
  PositionsProps &
  EmployeesProps &
  InstaProps &
  TimelineProps &
  CitationProps &
  OfficesProps &
  VisitProps &
  SliderProps &
  ConnectProps &
  ContactFormProps &
  ThreeColumnGridProps &
  VimeoProps &
  WpFormProps &
  PortfoliosProps &
  FullScreenImageProps &
  NewspostsProps &
  FreeTextProps &
  NewsletterformSectionProps &
  WTRegistrationPopupSectionProps;

/**
 * Routes each block type to its own component. Every component in /components/blocks is
 * getting the raw data from API.
 */

const Block = (props: Props) => {
  switch (props.internal && props.internal.type) {
    case 'WordPressAcf_hero':
      return <Hero {...props} />;

    case 'WordPressAcf_brands':
      return <Brands {...props} />;

    case 'WordPressAcf_news':
      return <News {...props} />;

    case 'WordPressAcf_text_and_image':
      return <TextAndImage {...props} />;

    case 'WordPressAcf_four_images_grid':
      return <FourImagesGrid {...props} />;

    case 'WordPressAcf_positions':
      return <Positions {...props} />;

    case 'WordPressAcf_employees':
      return <Employees {...props} />;

    // case 'WordPressAcf_instagram':
    //   return <InstagramBlock {...props} />;

    case 'WordPressAcf_timeline':
      return <Timeline {...props} />;

    case 'WordPressAcf_citation':
      return <Citation {...props} />;

    case 'WordPressAcf_slider':
      return <Slider {...props} />;

    case 'WordPressAcf_offices':
      return <Offices {...props} />;

    case 'WordPressAcf_visit':
      return <Visit {...props} />;

    case 'WordPressAcf_connect':
      return <Connect {...props} />;

    case 'WordPressAcf_wp_forms':
      return <WpForm {...props} />;

    case 'WordPressAcf_contact_form':
      return <ContactForm {...props} />;

    case 'WordPressAcf_three_column_grid':
      return <ThreeColumnGrid {...props} />;

    case 'WordPressAcf_vimeo':
      return <Vimeo {...props} />;

    case 'WordPressAcf_portfolios':
      return <Portfolios {...props} />;

    case 'WordPressAcf_full_screen_image':
      return <FullScreenImage {...props} />;

    case 'WordPressAcf_newsposts':
      return <Newsposts {...props} />;

    case 'WordPressAcf_free_text':
      return <FreeText {...props} />;

    case 'WordPressAcf_newsletter_form':
      return <NewsletterformSection {...props} />;

    case 'WordPressAcf_wt_registration_popup':
      return <WTRegistrationPopupSection {...props} />;

    default:
      return <div />;
  }
};

export default Block;
